<template>
	<div class="offers-container" v-if="hasAvailableOfferInCart()">
		<div class="offer-subcontainer offer-messaging">
			<div class="offer-emoji">
				🎉
			</div>
			<div class="offer-message">
				{{ name() }}, {{offerCouponMessage()}}
			</div>
		</div>
		<div class="offer-subcontainer all-offers">
			<template v-if="!allItemsHaveOffers()">
				<div v-for="(offer, index) in offers()" :key="getOfferKey(offer, index)" class="offer-wrapper">
					<offer-item :offer="offer"/>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import offersMixin from '@Mixin/offersMixin';
	import profileMixin from '@Mixin/profileMixin';
	import OfferItem from '@/components/checkout/OfferItem.vue';
	export default {
		mixins: [offersMixin, profileMixin],
		components: {
			'offer-item': OfferItem,
		},
		data() {
			return {
				offers: () => {
					let offers = this.getOffers;
					offers = _.filter(offers, (offer) => {
						return this.validOffer(offer);
					});
					return offers;
				},
				name: () => {
					return this.customerName;
				}
			};
		},
		methods: {
			validOffer(offer) {
				const hasOffer = this.offersOnItems(null, [offer]);
				// TODO allow for multiple redemptions of the same offer within the same order

				if (!offer.isValid() || hasOffer.length !== 0 || (offer.target === 'item' && !this.itemOfferIsValid(offer)) ) {
					return false;
				}
				return true;
			},
			offerCouponMessage() {
				const allOffersApplied = this.allItemsHaveOffers();
				const messageOffersAvailable = `we have some offers just for you!`;
				const messageOffersApplied = `you've applied the max offers for this order!`;
				const message = (allOffersApplied) ? messageOffersApplied : messageOffersAvailable;
				return message;
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	@import 'commonStyle/offers';
</style>


// WEBPACK FOOTER //
// src/components/checkout/Offers.vue